import Model from "@/models/Model";

export default class File extends Model {
    resource() {
        return "files";
    }

    static async findItemFromUrl(url) {
        return await File.custom(new File(), "fromUrl")
            .params({ url: encodeURIComponent(url) })
            .first()
            .catch(() => {
                return null;
            });
    }
}
